import React from 'react';
import PropTypes from 'prop-types';
import { BoundForm, BoundFormRow, Button, ButtonToolbar, FormChoice } from '@appfolio/react-gears';

const parseErrors = errors =>
  Object.assign({}, ...Object.keys(errors || {}).map((field) => {
    return { [field]: errors[field].join(', ') };
  }));

const RevokeForm = ({ errors, onCancel, onSubmit, readOnly, ...fields }) => (
  <BoundForm object={fields} onSubmit={onSubmit} errors={parseErrors(errors)}>
    <BoundFormRow
      name="identity_provider_type_id"
      label="Select Identity Provider Type"
      readOnly={readOnly}
      required
      stacked
      type="select"
    >
      <FormChoice value="1">TPortal</FormChoice>
      <FormChoice value="2">Property</FormChoice>
      <FormChoice value="3">OPortal</FormChoice>
      <FormChoice value="4">Wildcard</FormChoice>
      <FormChoice value="5">Internal</FormChoice>
      <FormChoice value="6">Vendor</FormChoice>
      <FormChoice value="7">Partner Api</FormChoice>
      <FormChoice value="8">Identity</FormChoice>
    </BoundFormRow>

    <BoundFormRow
      name="created_at_epoch"
      label="Before Timestamp"
      type="datetime-local"
      readOnly={readOnly}
      stacked
      hint="Revoke all earlier issued tokens. Defaults to current time."
    />

    <BoundFormRow
      name="emails"
      label="Email Addresses"
      type="textarea"
      readOnly={readOnly}
      required
      stacked
      hint="Enter one or more email addresses, separated by commas or newlines."
    />

    <ButtonToolbar>
      <Button
        type="submit"
        color="primary"
        disabled={readOnly}
        className="js-save-btn"
      >
        Save
      </Button>
      <Button
        color="secondary"
        onClick={onCancel}
        className="js-cancel-btn"
      >
        Cancel
      </Button>
    </ButtonToolbar>
  </BoundForm>
);

RevokeForm.propTypes = {
  identity_provider_type_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  created_at_epoch: PropTypes.string,
  emails: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
};

RevokeForm.defaultProps = {
  identity_provider_type_id: '1',
  created_at_epoch: '',
  emails: '',
  readOnly: false,
  errors: {},
};

export default RevokeForm;
